export default __webpack_public_path__ + "static/media/bombito.22c1d09b.svg";